import { Navigate, Outlet } from 'react-router-dom';

import { FullscreenLoader } from '@/shared/components/FullscreenLoader';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';
import { useOrgAccess } from '@/features/business';

interface BusinessGuardProps {
  /** 접근 권한이 없을 때 이동 경로 (기본: 마이페이지) */
  fallbackPath?: string;
}

/**
 * 기업 콘솔(/business) 접근 Guard. AuthGuard 하위에 중첩.
 *
 * 게이팅 기준은 UserType 단독이 아니라 **조직 접근 여부**다:
 *   - 계정 자체가 사업자(UserType.BUSINESS)이거나,
 *   - 초대받아 합류한 조직 ACTIVE 멤버십을 하나라도 보유하면 통과.
 * 초대받은 개인(INDIVIDUAL)도 콘솔에 들어올 수 있고, 조직을 나가면 자동 차단된다.
 *
 * 조직 미보유 상태(사업자지만 멤버십 0)는 통과시키고, 레이아웃에서 안내한다.
 */
export default function BusinessGuard({
  fallbackPath = PATHS.MYPAGE,
}: BusinessGuardProps) {
  const { hasAccess, loading } = useOrgAccess();

  if (loading) return <FullscreenLoader />;
  if (!hasAccess) return <Navigate to={fallbackPath} replace />;

  return <Outlet />;
}
